import {
    EmailMarketingKpis,
    EmailMarketingLocation,
    EmailMarketingSender,
    EmailMarketingTemplateOption,
    OrganizationCampaign
} from 'model/emailMarketing';

export enum EmailMarketingStatus {
    Initial,
    Error,
    Fetching,
    FetchSuccess
}

export interface EmailMarketingState {
    status: EmailMarketingStatus;
    error?: string;
    loadingLocations: boolean;
    loadingTemplates: boolean;
    loadingCampaigns: boolean;
    loadingCampaign: boolean;
    loadingKpis: boolean;
    loadingSenders: boolean;
    // First load finished (or failed), so an empty list really means there's nothing yet.
    locationsLoaded: boolean;
    templatesLoaded: boolean;
    campaignsLoaded: boolean;
    // Create, update, duplicate, send or delete in progress.
    saving: boolean;
    locations: Array<EmailMarketingLocation>;
    templates: Array<EmailMarketingTemplateOption>;
    // Empty until the senders are loaded.
    senders: Array<EmailMarketingSender>;
    campaigns: Array<OrganizationCampaign>;
    // Last opened campaign, with totals and per-location counts.
    campaign?: OrganizationCampaign;
    kpis?: EmailMarketingKpis;
}
